// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__3EIr7","modalForm":"UpgradeEpcsModal_modalForm__2BYaz","modalFooter":"UpgradeEpcsModal_modalFooter__23tj4"};